import { render } from "./TrainingsView.vue?vue&type=template&id=8c31121c&ts=true"
import script from "./TrainingsView.vue?vue&type=script&lang=ts"
export * from "./TrainingsView.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__